









import Vue from 'vue';

export default Vue.extend({
  props: {
    message: {
      default: '',
    },
    duration: {
      default: 6000,
    },
  },

  data: () => ({
    currentError: {
      message: '',
      active: false,
    },
  }),

  methods: {
    resetMessage() {
      this.currentError.active = false;
      this.currentError.message = '';
      this.$emit('closed', true);
    },
  },

  watch: {
    message(currentMessage) {
      if (currentMessage !== '') {
        this.currentError.active = true;
        this.currentError.message = currentMessage;
      }
    },
  },
});
